<main class="grow content pt-5" id="content" role="content">
    <div class="container-fixed mt-10" id="content_container">
        <span class="font-semibold">Input with Button</span>
        <div class="bg-white p-4 rounded-md shadow-md w-full max-w-sm card" *ngFor="let item of inputWithButton">
            <label class="block text-sm font-semibold text-gray-800 mb-2">{{item.header}}</label>
            <div class="flex rounded-md overflow-hidden border border-gray-300">
                <input type="text" [placeholder]="item.placeholder"
                    class="flex-1 px-3 py-2 text-sm text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-0" />
                <button class="bg-blue-500 text-white px-4 py-2 text-sm font-medium btn-primary">
                    {{item.buttonName}}
                </button>
            </div>
        </div>
    </div>
</main>